// import { ConsiderRegisterComponent } from "../../components/RegisterSystem/ConsiderRegisterComponent";
import { ConsiderProfileComponent } from '../../components/RegisterSystem/ConsiderProfileComponent';
import { Footer } from '../../components/share/Footer';
import { NavbarComponent } from "../../components/share/NavbarComponent";
import { HeadTitle } from "../../components/share/HeadTitle";

export function ConsiderProfileContainer() {
    const titleName = "รายการคำขอเปลี่ยนข้อมูลส่วนตัว";
    return (
        <div className="page-container bg-landing">

            <NavbarComponent />
            <HeadTitle title={titleName} />
            <ConsiderProfileComponent />
            <Footer />
        </div>
    );
}